var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.tips},[_c('div',[_vm._v("确定移除该设备？")]),_c('div',{class:_vm.$style.warnText},[_vm._v(" 移除后，当前企业将不能再查看和管理该设备！ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }